import { useState } from 'react';
import { toast } from 'react-toastify';
import aiApi from '../api/ai-api';

export const useTranslateFields = () => {
  const [translating, setTranslating] = useState(false);

  const translate = async (fields, htmlFields = []) => {
    setTranslating(true);
    try {
      const { success, data, message } = await aiApi.translate(fields, htmlFields);
      if (!success) {
        toast.error(message || 'Prevod nije uspeo.');
        return null;
      }
      return data;
    } finally {
      setTranslating(false);
    }
  };

  return { translating, translate };
};
